import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import api from '../api/client';

export default function Registro() {
    const [datos, setDatos] = useState({
        nombre: '', apellido_paterno: '', apellido_materno: '', correo: '', contrasena: '', confirmar: ''
    });
    const [verPass, setVerPass] = useState(false);
    const [error, setError] = useState('');
    const [cargando, setCargando] = useState(false);
    const navigate = useNavigate();

    const cambio = (campo) => (e) => setDatos({ ...datos, [campo]: e.target.value });

    const enviar = async (e) => {
        e.preventDefault();
        setError('');
        if (!datos.nombre || !datos.apellido_paterno || !datos.correo || !datos.contrasena) {
            setError('Completa los campos obligatorios'); return;
        }
        if (datos.contrasena.length < 4) { setError('La contrasena debe tener al menos 4 caracteres'); return; }
        if (datos.contrasena !== datos.confirmar) { setError('Las contrasenas no coinciden'); return; }

        setCargando(true);
        try {
            await api.post('/auth/registro', {
                nombre: datos.nombre,
                apellido_paterno: datos.apellido_paterno,
                apellido_materno: datos.apellido_materno || null,
                correo: datos.correo,
                contrasena: datos.contrasena
            });
            navigate('/verificar-correo', { state: { correo: datos.correo } });
        } catch (err) {
            if (!err.response) {
                setError('No se puede conectar al servidor. Verifica que el backend este corriendo (npm start en /backend) y que XAMPP MySQL este activo.');
                return;
            }
            setError(err.response?.data?.error || `Error ${err.response.status}: no se pudo registrar`);
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="auth-wrapper">
            <div className="auth-card">
                <h1 className="auth-title">Crear Cuenta</h1>
                <p className="auth-subtitle">Unete a Chucho Cursos</p>

                {error && <div className="error-msg">{error}</div>}

                <form onSubmit={enviar}>
                    <div className="auth-grid-2">
                        <div className="form-group">
                            <input
                                className="input"
                                placeholder="Nombre *"
                                value={datos.nombre}
                                onChange={cambio('nombre')}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                className="input"
                                placeholder="Apellido Paterno *"
                                value={datos.apellido_paterno}
                                onChange={cambio('apellido_paterno')}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <input
                            className="input"
                            placeholder="Apellido Materno (Opcional)"
                            value={datos.apellido_materno}
                            onChange={cambio('apellido_materno')}
                        />
                    </div>

                    <div className="form-group">
                        <div className="input-icono">
                            <FiMail className="icono" size={16} />
                            <input
                                className="input"
                                type="email"
                                placeholder="Correo electronico *"
                                value={datos.correo}
                                onChange={cambio('correo')}
                            />
                        </div>
                    </div>

                    <div className="auth-grid-2">
                        <div className="form-group">
                            <div className="input-icono">
                                <FiLock className="icono" size={16} />
                                <input
                                    className="input con-icono-derecha"
                                    type={verPass ? 'text' : 'password'}
                                    placeholder="Contrasena *"
                                    value={datos.contrasena}
                                    onChange={cambio('contrasena')}
                                />
                                <button type="button" className="icono-derecha" onClick={() => setVerPass(v => !v)}>
                                    {verPass ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                                </button>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="input-icono">
                                <FiLock className="icono" size={16} />
                                <input
                                    className="input"
                                    type={verPass ? 'text' : 'password'}
                                    placeholder="Confirmar *"
                                    value={datos.confirmar}
                                    onChange={cambio('confirmar')}
                                />
                            </div>
                        </div>
                    </div>

                    <button type="submit" className="btn btn-primario btn-bloque" disabled={cargando}>
                        {cargando ? 'Registrando...' : 'Registrarme'}
                    </button>

                    <div className="auth-link">
                        ¿Ya tienes cuenta? <Link to="/login">Ir al Login</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
